// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2TFxc","footer":"ChangeClinic_footer__1saud"};